import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Русский язык. 6 класс",
        subject: "Секреты языкового анализа: морфологический анализ глагола",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Секреты языкового анализа: морфологический анализ глагола",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Васильевых Ирина Павловна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории филологического общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>Морфологический анализ слов разных частей речи и более всего глагола и его особых форм — причастия и деепричастия — один из наиболее сложных для школьников видов языкового анализа. </p>
                                </div>
                                <div style='padding: 2.4rem; '>Глагол — самая сложная часть речи и в плане содержания, и в плане выражения. В системе частей речи он обладает наибольшим количеством морфологических категорий, в связи с чем имеет и наиболее разветвлённую систему грамматических форм, что усложняет для учеников задачу их распознавания и квалификации. </div>
                                <div style='padding: 2.4rem; padding-top: 0;'>Это обусловлено как сложностью самого языкового материала, с которым работают обучающиеся, так и недооценкой важности использования функционально-семантического подхода к изучению морфологических свойств слов этой части речи, который требует от школьников осмысления взаимосвязи и взаимообусловленности глагольных категорий.</div>
                                <div style='padding: 2.4rem; padding-top: 0;'>Глагольные словоформы могут выражать бóльшее количество грамматических значений, чем словоформы других частей речи, и имеют сложную и неоднородную систему формального выражения этих грамматических значений, включающую не только синтетические, но и аналитические средства. Это создаёт для школьников дополнительные трудности при проведении морфологического анализа глагола.</div>
                                <div style='padding: 2.4rem; padding-top: 0;'>
                                    <p>Осмысление этого материала и, как следствие, овладение соответствующими приёмами определения грамматических значений возможно при условии реализации функционального подхода, что предполагает:</p>
                                </div>
                                <div style='padding: 2.4rem; padding-top: 0;'>
                                    <ol>
                                    <li>осмысление значения грамматических категорий;</li>
                                    <li>осмысление взаимосвязи и взаимозависимости грамматических категорий;</li>
                                    <li>овладение навыками анализа средств выражения грамматических значений — окончаний и грамматических суффиксов;</li>
                                    <li>овладение навыками выявлять смысловые и грамматические связи между словами в словосочетании и предложении.</li>
                                    </ol>
                                </div>
`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Богатырёва И.И., Волошина О.А. Словарь школьных лингвистических терминов. — Москва: Добросвет, Издательство «КДУ», 2012",
                "Ефремова Т.Ф. Словарь грамматических трудностей русского языка: более 2500 слов / Т.Ф. Ефремова, В.Г. Костомаров. — Москва: Астрель: АСТ: Хранитель, 2007",
                "Касаткин Л.Л. Современный русский язык. Словарь-справочник: пособие для учителей общеобразовательных учреждений / Л.Л. Касаткин, Е.В. Клобуков, П.А. Лекант; под ред. П.А. Леканта. — 3-е изд. — Москва: Просвещение, 2010",
                "Львов М.Р. Словарь-справочник по методике русского языка: учеб. пособие для студентов пед. ин-тов. — Москва: Просвещение, 1988",
                "Панова Г.И. Морфология русского языка: Энциклопедический словарь-справочник. — Москва: КомКнига, 2010",
                "Текучёв А.В. Методика русского языка в средней школе: учебник для студентов пед. ин-тов. — Изд. 3-е, перераб. — Москва: Просвещение, 1980",
            ],
            filesToDownload: [
                {
                    link: "./files/task1.pdf",
                    fileName: "Дополнительны задания для обучающихся"
                },
                {
                    link: "./files/task2.pdf",
                    fileName: "Дополнительные задания для учителя"
                }
            ]
        }
    ],
};
